import { BeneficiaryModel } from './../model/beneficiary.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { BaseService } from './base.services';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { BPAYDetailsModel } from '../model/bpay-details.model';

@Injectable()
export class BPAYDetailsService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService,
    private store: Store<any>) {
    super(toastr);
  }

  getAccountBPAYDetails(accountId: number): Observable<BPAYDetailsModel> {
    return this.http.get<BPAYDetailsModel>(environment.apiUrl + `/member-portal/account/${accountId}/bpay-details`, { headers: this.headers() });
  }

}
